export default __webpack_public_path__ + "static/media/SIW400G_T012_15_20_25_W1.0bb8aaf2.webp";